<script setup lang="ts">
  import { computed } from 'vue';
  import { NavigationCategory, NavigationItem } from '@/shared/lib';
  import { SelectInput } from '@/shared/ui';
  import ModuleDropdown from './ModuleDropdown.vue';

  interface Props {
    categories: NavigationCategory[];
    modelValue?: string;
    selectedModules?: NavigationItem[];
  }

  const props = withDefaults(defineProps<Props>(), {
    modelValue: '',
    selectedModules: () => [],
  });

  const emit = defineEmits<{
    'category-change': [categoryId: string];
    'update:modelValue': [value: string];
    'modules-selected': [modules: NavigationItem[]];
    'item-navigate': [item: NavigationItem];
  }>();

  const categoryOptions = computed(() =>
    props.categories.map((category) => ({
      id: category.id,
      name: category.name,
    }))
  );

  const shouldShowModuleDropdown = computed(() => {
    const category = props.categories.find((cat) => cat.id === props.modelValue);
    return category?.type === 'module';
  });

  const availableModules = computed(() => {
    const category = props.categories.find((cat) => cat.id === props.modelValue);
    return category?.items || [];
  });

  const handleCategoryChange = (categoryId: string) => {
    emit('category-change', categoryId);
    emit('update:modelValue', categoryId);
    emit('modules-selected', []);
  };

  const handleModulesSelected = (modules: NavigationItem[]) => {
    emit('modules-selected', modules);
  };

  const handleItemNavigate = (item: NavigationItem) => {
    emit('item-navigate', item);
  };
</script>

<template>
  <div class="space-y-3">
    <SelectInput
      :model-value="modelValue"
      :options="categoryOptions"
      label="Navegação"
      class="shadow rounded-lg"
      @update:model-value="handleCategoryChange"
    />

    <ModuleDropdown
      v-if="shouldShowModuleDropdown"
      :modules="availableModules"
      :selected-modules="selectedModules"
      @modules-selected="handleModulesSelected"
    />
  </div>
</template>
